import React from "react";
import { optimizeImage } from "@/lib/mediaUrls";

// Host-only compact deck strip: slide count, thumbnails (tap to show),
// and an "Up next" preview. Attendees never render this.
export const HostSlideStrip = ({ slides, activeIdx, onJump, pending }) => {
  if (!slides.length) return null;
  const next = activeIdx >= 0 ? slides[activeIdx + 1] : slides[0];
  return (
    <div className="px-3 py-2 bg-black/70 border-t border-purple-500/20" data-testid="workshop-host-strip">
      <div className="flex items-center justify-between text-[11px] text-white/60 mb-1.5">
        <span data-testid="workshop-slide-count">{slides.length} {slides.length === 1 ? "slide" : "slides"}</span>
        <span data-testid="workshop-up-next">{next ? `Up next: slide ${slides.indexOf(next) + 1}` : "Last slide"}</span>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1" style={{ WebkitOverflowScrolling: "touch" }}>
        {slides.map((s, i) => (
          <button
            key={s.slide_id}
            type="button"
            disabled={pending}
            onClick={() => onJump(s.slide_id)}
            className={`relative shrink-0 w-20 rounded-md overflow-hidden border-2 transition-colors ${
              i === activeIdx ? "border-fuchsia-400" : next && s.slide_id === next.slide_id ? "border-amber-300/70" : "border-white/10"
            }`}
            style={{ aspectRatio: "16 / 9" }}
            aria-label={`Show slide ${i + 1}`}
            data-testid={`workshop-thumb-${i}`}
          >
            <img src={optimizeImage(s.image_url, 'thumb')} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover bg-black" />
            <span className="absolute bottom-0 right-0 px-1 text-[9px] font-bold bg-black/70 text-white">{i + 1}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HostSlideStrip;
